import * as firebase from 'firebase';
require("firebase/firestore");

var collectionMeta={
	"users":{
		"fields":{
			"firstname":"",
			"lastname":"",
			"email": "",
			"gender":"",
			"birthday":"",
			"group":"",
			"subGroups":"",
			"roles":"-",
			"code":""
		},
		"collections":[],
	},
	"announcements":{
		"fields":{
			"title":"",
			"content":"",
			"active":false,
			"start":"",
			"end":"",
			"group": "REFERENCE:/groups/yjJ1lnx7r8wjAoC1o755"
			// "group": new firebase.firestore().doc("/groups/yjJ1lnx7r8wjAoC1o755")
			// "group": new firebase.app.firestore().DocumentReference("/groups/yjJ1lnx7r8wjAoC1o755")
			// "group": "-"
		},
		"collections":[],
	},
	"leaders": {
		"fields":{
			"name":"",
			"function":"",
			"leaderImage":""
		},
		"collections":[]
	},
	"groups":{ 
		"fields":{
			"name":"",
			"registerCode":""
		},
		"collections":[]
	},
	"TEMPLATE":{
		"fields":{},
		"collections":[],
	}
}
module.exports = collectionMeta;


// WEBPACK FOOTER //
// ./src/config/firestoreschema.js